import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const statisticalSummaryCalculatorDescription: CalculatorDescription = {
  id: CalculatorId.SUMMARY,
  title: 'Statistical summary calculator',
  metaTitle: 'Statistical Summary Calculator - Comprehensive Data Analysis',
  description: 'Calculate a comprehensive statistical summary of your dataset including mean, median, mode, standard deviation, and more.',
  metaDescription: 'Free online statistical summary calculator. Get a complete analysis of your dataset with our comprehensive statistical tool.',
  howTo: {
    title: 'How to get a statistical summary',
    steps: [
      'Enter your data values in the input field',
      'Separate values with commas, spaces, or line breaks',
      'The calculator will automatically compute all key statistics',
      'View the results organized by category (central tendency, dispersion, etc.)',
      'Use the distribution plot to visualize your data'
    ],
    graphic: {
      description: 'Visual representation of statistical summary calculation'
    }
  },
  examples: [
    {
      title: 'Comprehensive analysis of test scores',
      description: 'Complete statistical breakdown of student performance',
      dataDescription: 'Test scores from a class of 25 students',
      insights: [
        'Mean of 78.2 with median of 80 suggests slight negative skew',
        'Standard deviation of 12.3 indicates moderate spread',
        'Range of 55 points shows considerable variation in performance',
        'Multiple modes at 75 and 85 suggest bimodal distribution'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['45', '55', '60', '65', '65', '70', '70', '72', '75', '75', '75', '78', '80', '80', '82', '85', '85', '85', '88', '90', '90', '92', '95', '98', '100'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.FIVE_NUMBER_SUMMARY,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.KURTOSIS
  ]
}; 